module.exports = __webpack_public_path__ + "img/appAsset--pos-ax.f6ff304b.svg";